import "./CreateReservationModalFooter.scss";

type CreateReservationModalFooterProps = {
  children?: React.ReactNode;
};

export const CreateReservationModalFooter = ({
  children,
}: CreateReservationModalFooterProps) => {
  return (
    <footer className="ui-consent-modal-footer bg-white shadow">
      {children}
    </footer>
  );
};
